<template>
    <div>
        <b-card header="My Messages">
            <b-row>
                <b-col class="text-right with-padding-bottom">
                    <b-btn href="/contact" variant="info"><i class="fa fa-envelope"></i>&nbsp; Contact Us</b-btn>
                </b-col>
            </b-row>
            <div class="table-responsive">
                <b-table bordered striped hover show-empty
                        :items="messages"
                        :fields="fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        @filtered="onFiltered"
                >
                    <template v-slot:cell(subject)="row">
                        <span v-text="row.item.subject" :class="row.item.unread ? 'unread' : null" />
                    </template>
                    <template v-slot:cell(status_display)="row">
                        <span v-text="row.item.status_display" :class="row.item.unread ? 'unread' : null" />
                    </template>
                    <template v-slot:cell(updated_at)="row">
                        <span v-text=" formatDateTimeFromUTC( row.item.updated_at )" :class="row.item.unread ? 'unread' : null" />
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-btn size="sm" @click="viewMessage(row.item)">View</b-btn>
                        <b-btn size="sm" variant="danger" @click="deleteMessage(row.item, row.index)">Delete</b-btn>
                    </template>
                </b-table>
            </div>

            <b-row>
                <b-col lg="6" >
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
    import FormatsDates from "../mixins/FormatsDates";

    export default {
        mixins: [ FormatsDates ],

        props: {
            messages: {},
        },

        data() {
            return {
                totalRows: 0,
                perPage: 25,
                currentPage: 1,
                sortBy: null,
                sortDesc: false,
                filter: null,
                fields: [
                    {
                        key: 'subject',
                        label: 'Subject',
                        sortable: true,
                    },
                    {
                        key: 'status_display',
                        label: 'Status',
                        sortable: true,
                    },
                    {
                        key: 'updated_at',
                        label: 'Last Update',
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print'
                    }
                ],
            }
        },
        
        methods: {
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

            viewMessage(message) {
                window.location = `/messages/${message.id}`;
            },

            deleteMessage(message, index) {
                console.log("Delete")
                console.debug("Message", message);
                console.debug("Message Index", index);

                let form = new Form();
                
                form.submit("delete", "/messages/" + message.id)
                    .then(function(response) {
                        console.log("Delete complete");
                    });

                this.messages.splice(index, 1);
            }
        },

        mounted() {
            this.totalRows = this.messages.length;
        },
    }
</script>

<style>
.unread { font-weight: 600; }
</style>
